module.exports = __webpack_public_path__ + "img/package-active.addd245f.png";